module.exports = __webpack_public_path__ + "static/media/fa-regular-400.f4175677.ttf";